/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { DeactivateUserOptions, DeactivateUserResponses } from '../types/DeactivateUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Creates an asynchronous deactivation request, or re-triggers a FAILED one. Trading, funding, and transfers are blocked immediately; a background daemon cancels open orders, closes positions at market price, repays outstanding debt and interest, and sweeps remaining cash into the user's global account. The request is only marked COMPLETED once every step succeeds. Poll GET /v1/user/{user_id}/deactivation for the outcome.
 * @summary Deactivate a user's account (admin)
 * {@link /v1/user/:user_id/deactivate}
 */
export function deactivateUser<ThrowOnError extends boolean = true>(
  options: Options<DeactivateUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<DeactivateUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/user/{user_id}/deactivate',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<DeactivateUserResponses, ThrowOnError>>,
  )
}
